<template>
    <v-col
        cols="12"
        md="4"
        sm="6"
    >
    <v-lazy
        v-model="isActive"
        :options="{
        threshold: 0.2
        }"
        min-height="300"
        transition="fade-transition"
    >
    <v-card flat>
        <v-card>
        <v-card-text class="pb-0">
            <div>Metro Map of</div>
            <p class="headline text--primary truncate pb-0 mb-0">
            {{d.data_name}}
            </p>
            <p>{{d.creation_date | dateParse('YYYY-MM-DD HH:mm:ss') | dateFormat('DD MMM. YYYY // HH:mm')}}</p>
        </v-card-text>

        <v-card-text class="py-0">
            <MiniMetro :id="`svg_` + d.id" :lines="d.lines.paths" :options="d.lines.options" style="height:200px"></MiniMetro>
        </v-card-text>
        <v-divider/>
        <v-card-subtitle class="py-2">
            <v-row justify="space-around" class="mx-0">
            <v-chip
                class="ma-2"
                color="subtle"
                outlined
                small
            >
                <v-avatar
                left
                class="subtle darken-1 white--text"
                >
                {{d.nElements}}
                </v-avatar>
                Elements
                </v-chip>
            <v-chip
                class="ma-2"
                color="subtle "
                outlined
                small
            >
                <v-avatar
                left
                class="subtle darken-1 white--text"
                >
                {{d.nSetColumns}}
                </v-avatar>
                Sets
                </v-chip></v-row>
            <v-row justify="space-between" class="mx-1 mt-8 mb-1">
                <v-btn small tile class="textSecondary--text" color="secondary" :to="{ name: 'mapDetail', params: { mapId: d.id }}">
                    <v-icon left>mdi-map</v-icon> View
                </v-btn>
                <v-btn medium color="primary" class="mb-2" icon @click="showOverlay = !showOverlay">
                <v-icon  >mdi-information-outline</v-icon>
                </v-btn>
            </v-row>
        </v-card-subtitle>
            <!--<v-container class="overlayed d-flex flex-column justify-space-around">
                <v-card-title  color="white--text">{{d.data_name}}</v-card-title>
                <div color="text">{{d.data_description}}</div>
                <v-container>
                <v-spacer/>
                <v-btn class="ma-2" tile outlined color="success" :to="{ name: 'mapDetail', params: { mapId: d.id }}">
                    <v-icon left>mdi-map</v-icon> View
                </v-btn>
                <v-spacer/>
                </v-container>
            </v-container>-->
        </v-card>
        <v-fade-transition>
        <v-card color="primary" class="overlayed" v-show="showOverlay">
        <v-card-text class="pb-0">
            <div>Metro Map of</div>
            <p class="headline text--primary">
            {{d.data_name}}
            </p>
        </v-card-text>
        <v-card-text>
            {{d.data_description}}
        </v-card-text>
        <v-card-text class="mx-3">
            <v-row class="d-flex justify-start">
            <span style="width: 150px">Support Algorithm:</span><span> <strong>{{d.support_algorithm_readable}}</strong></span>
            </v-row>
            <v-row class="d-flex justify-start">
            <span style="width: 150px">Insertion Algorithm:</span><span>  <strong>{{d.insertion_algorithm_readable}}</strong></span>
            </v-row>
            <v-row class="d-flex justify-start">
            <span style="width: 150px">Initial Layout:</span><span>  <strong>{{d.initial_layout_algorithm_readable}}</strong></span>
            </v-row>
            <v-row class="d-flex justify-start">
            <span style="width: 150px">Schematization:</span><span>  <strong>{{d.schematization_algorithm_readable}}</strong></span>
            </v-row>
        </v-card-text>
        <v-card-actions class="pb-7 px-4 d-flex justify-space-between" style="position: absolute; bottom: 0; width:100%">
        <v-btn small tile class="textSecondary--text" color="secondary" :to="{ name: 'mapDetail', params: { mapId: d.id }}">
            <v-icon left>mdi-map</v-icon> View
        </v-btn>
        <v-btn small tile class="textSecondary--text" color="secondary" :to="{ name: 'dataDetail', params: { dataId: d.data }}">
            <v-icon left>mdi-pencil-outline</v-icon> Create New
        </v-btn>
        <v-btn small tile class="textSecondary--text" color="secondary" @click="showOverlay = !showOverlay">
            Close
        </v-btn>
        </v-card-actions>
        </v-card>
        </v-fade-transition>
    </v-card>
    </v-lazy>
    </v-col>
</template>

<script>
import MiniMetro from '../components/MiniMetro.vue'

export default {
  name: 'DataCard',
  components: {
    MiniMetro
  },
  props: {
    d: Object
  },
  data () {
    return {
      showOverlay: false
    }
  }

}
</script>

<style scoped>
  .truncate {
    font-weight: 500 !important;
    display:inline-block;
    max-width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

.hoverTrick {

}

.overlayed {
  z-index: 10;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  color: white;
  background-color: rgba(0,0,0,0.8);
  opacity:1.0;
  visibility: visible;
  transition: all .5s ease;
}
</style>
